import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-none"
}
const _hoisted_2 = { class: "p-field-radiobutton" }
const _hoisted_3 = { for: "ExternalSensorTypeBticino" }
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = { for: "ExternalSensorTypeVantage" }
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "mb-0 ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputSwitch = _resolveComponent("InputSwitch")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    (_ctx.settings.isExternalSensorTypeVisible)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ExternalSensorType")), 1),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_RadioButton, {
              id: "ExternalSensorTypeBticino",
              name: "externalSensorType",
              value: _ctx.ExternalSensorType.Bticino,
              modelValue: _ctx.settings.externalSensorType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.externalSensorType = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.BticinoSensor")), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_RadioButton, {
              id: "ExternalSensorTypeVantage",
              name: "externalSensorType",
              value: _ctx.ExternalSensorType.Vantage,
              modelValue: _ctx.settings.externalSensorType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.settings.externalSensorType = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.VantageSensor")), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.settings.isLedmanagedVisible)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.LedEnabled")), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.settings.isLedManaged,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.settings.isLedManaged = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Enabled")), 1)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}